var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Header"},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("Find my School")]),_c('div',{staticClass:"logos"},[_c('img',{staticClass:"education-state-logo",attrs:{"src":"/de-education-state-logo.png","height":"60","alt":"The Education State, Victoria State Government, Department of Education"}})])])])
}]

export { render, staticRenderFns }